import { Component } from '@angular/core';
import { TrpcService } from '../../services/trpc/trpc.service';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { dropdownOption } from '../../types/common';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-dre-report',
  templateUrl: './dre-report.component.html',
  styleUrl: './dre-report.component.scss'
})
export class DreReportComponent {
  version = environment.version;
  activeFile = environment.activeFile;

  loading: boolean = true;
  commonInfo: any[] = [];

  ticketsIssuedData: any[] = [];
  ticketsCollectedData: any[] = [];

  monthlyValidationsData: any[] = [];
  otherIncomeData: any[] = [];

  dreReportData: any[] = [];

  shifts: dropdownOption[] =[
    { name: "All", code: 'all' },
    { name: "1", code: '1' },
    { name: "2", code: '2' },
    { name: "3", code: '3' },
    { name: "4", code: '4' },
    { name: "5", code: '5' },
    { name: "6", code: '6' },
    { name: "7", code: '7' },
    { name: "8", code: '8' },
    { name: "9", code: '9' },
    { name: "10", code: '10' },
  ];

  selectedShift: string = 'all';
  dreReportLocation: string = '';
  dreReportDate: string = '';

  constructor(
    public route: ActivatedRoute,
    private trpcService: TrpcService,
    private messageService: MessageService
  ) {
    this.route.params.subscribe((queryParams) => {
      this.dreReportLocation = queryParams['location'];

      let [year, month, day] = [queryParams['date'].slice(0,4), queryParams['date'].slice(4,6), queryParams['date'].slice(6,8)]
      const reportDate: string = [month, day, year].join("/");

      this.dreReportDate = reportDate;
      this.loadReportData();

    })
  }

  /**
   * Get the data for the DRE report
   */
  async loadReportData(): Promise<void> {

    this.messageService.clear();
    this.loading = true;
    this.dreReportData = [];
    let params = {shift: [this.selectedShift], date: this.dreReportDate, location: this.dreReportLocation}
    if(this.selectedShift == 'all') {
      params['shift'] = this.shifts.reduce(function(filtered: string[], option) {
        if (option.code !== 'all') {
           let someNewValue: string = String(option.code);
           filtered.push(someNewValue);
        }
        return filtered;
      }, []);
    }
    let dreReportResponseData: any = await this.trpcService.trpc.reports.getDREReport.query(params).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
        closable: false
      });
      this.loading = false;
    });

    if(dreReportResponseData) {
      console.log(dreReportResponseData);

      for (let index = 0; index < dreReportResponseData.length; index++) {
        const dreReportData = dreReportResponseData[index];
        this.dreReportData.push({
          commonInfo: [{
            "amexDeposit": dreReportData.amexDeposit,
            "bankDeposit": dreReportData.bankDeposit,
            "depositAmount": dreReportData.depositAmount,
            "visaDeposit": dreReportData.visaDeposit,
            "date": dreReportData.date,
            "location": dreReportData.location,
            "shift": dreReportData.shift,
          }],
          ticketsIssuedData: dreReportData.Grid1Array.filter((data: any) => data?.Trans1Lane),
          ticketsCollectedData: dreReportData.Grid1Array.filter((data: any) => data?.Trans2Collected),
          monthlyValidationsData: dreReportData.Grid2Array,
          otherIncomeData: dreReportData.Grid3Array
        });
      }

      if(!dreReportResponseData.length) {
        this.messageService.add({
          severity: "error",
          detail: "No data found for this report.",
          closable: false
        });
      }

    }
    this.loading = false;
  }

  /**
   * Reload DE report on Shift change
   */
  refreshReport(): void {
    this.loadReportData();
  }
}
